// 芬兰语

export default{
    shipping_method: 'Toimitustapa',
    shipping_time: 'Toimitusaika',
    costs: 'Kustannukset',
    shipping_to: 'Toimitusosoite'
}


// WEBPACK FOOTER //
// ./src/i18n/fi.js